import styled, { css } from "styled-components"
import Breakpoints from "../breakpoints"

export const PlatformLayersImg = styled.img`
  display: none;

  @media (min-width: ${Breakpoints.md}) {
    display: block;
    max-width: 100%;
    object-fit: contain;
    grid-column: 1 / -1;
    margin-top: 48px;
    margin-bottom: 64px;
    justify-self: center;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: -17px;
    margin-bottom: 129px;
    grid-column: 3 / -2;
  }
`

export const OverlayStyle = css`
  background: var(--light-background);
`
